import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import DefaultLayout from './DefaultLayout';


const layoutSelector = (state) => state.layout;

const dashboardTypeSelector = createSelector(
  layoutSelector,
  R.propOr('admin', 'dashboardType')
)


const selector = createStructuredSelector({
  layout: layoutSelector,
  dashboardType: dashboardTypeSelector
});

export default withRouter(connect(selector)(DefaultLayout));
